import { render, staticRenderFns } from "./CreateCommunicationFolioModal.vue?vue&type=template&id=df5f0044&scoped=true"
import script from "./CreateCommunicationFolioModal.vue?vue&type=script&lang=js"
export * from "./CreateCommunicationFolioModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCommunicationFolioModal.vue?vue&type=style&index=0&id=df5f0044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5f0044",
  null
  
)

export default component.exports